<template>
  <swiper :options="swiperOption" ref="mySwiper" class="swiper-container">
    <!-- slides -->
    <swiper-slide 
        v-for="(item, index) in list" 
        :key="index" 
        class="swiper-slide" 
        :style="{backgroundImage:`url(${item.img})`}">
    </swiper-slide>
    <!-- Optional controls -->
    <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div>
  </swiper>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
    name:'Swiper',
    props:["list"],
    components: {
        swiper,
        swiperSlide
    },    
    data(){
        return{
            swiperOption: {
              effect: 'fade',
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },          
            },
        }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    mounted() {

    },
}
</script>
<style scope>
.swiper-container{width:100%;height:100%;}
.swiper-slide{background-position:center;background-size:cover;background-repeat:no-repeat;background-size: contain;background-color:#fff;border:1px solid #fff;}

.swiper-button-prev,.swiper-button-next{width:50%!important;height:100%!important;background:none!important;top:0px!important;border:none!important;outline:none!important;background-color:#ccc;cursor:e-resize!important;}
/* .swiper-button-prev{right:0px;}
.swiper-button-next{left:0px;} */
@media (max-width: 768px) {
.top_nav{display:flex;}
.swiper-button-prev,.swiper-button-next{display:none;}
}
</style>